import { useLayoutEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "motion/react";
import Iframe from "react-iframe";
import { useOverlayContext } from "../../functional-components/OverlayContext";
import { createPortal } from "react-dom";
import { RemoveScroll } from "react-remove-scroll";

export default function RoomEditorOverlay({
  isOpen = false,
  close = () => {},
  initialFloor
}) {
  const modalRef = useRef(null);
  const [modalRoot, setModalRoot] = useState();
  const portalId = "roomeditor-portal-root";

  const { setOverlayOpened } = useOverlayContext();

  useLayoutEffect(() => {
    if (isOpen) {
      setOverlayOpened(true);
    } else {
      if (modalRef.current) {
        setOverlayOpened(false);
      }
    }
  }, [isOpen, setOverlayOpened]);

  useLayoutEffect(() => {
    let _modalRoot = document.getElementById(portalId);
    if (!_modalRoot) {
      _modalRoot = document.createElement("div");
      _modalRoot.setAttribute("id", portalId);
      document.body.append(_modalRoot);
    }
    setModalRoot(_modalRoot);
  }, []);

  return modalRoot
    ? createPortal(
        <AnimatePresence>
          {isOpen && (
            <motion.div
              ref={modalRef}
              style={{
                position: "fixed",
                top: "var(--padding-top)",
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 5000,
                backgroundColor: "#3e3e3e",
                color: "#fff",
                userSelect: "none",
                touchAction: "none"
              }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <RemoveScroll removeScrollBar={false} enabled forwardProps>
                <Iframe
                  url={
                    "https://room-designer.bjelin.com/?hide-logo=1&floor=" +
                    initialFloor
                  }
                  width="100%"
                  height="100%"
                  id="room_editor"
                  className=""
                  display="block"
                  position="relative"
                  allowFullScreen
                  frameBorder={0}
                />
              </RemoveScroll>
              <motion.div
                style={{
                  position: "absolute",
                  top: "calc(3em + var(--safe-area-inset-top))",
                  right: "2em",
                  width: "2.5em",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  rowGap: "2em",
                  fontSize: "1em",
                  touchAction: "none",
                  filter: "drop-shadow(0 0 4px RGBA(0,0,0,0.5))",
                  zIndex: "inherit"
                }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
              >
                <motion.div
                  style={{
                    width: "2.5em"
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                    viewBox="0 0 320 512"
                    fill="currentColor"
                    style={{ height: "2.5em", cursor: "pointer" }}
                    onClick={() => {
                      close();
                    }}
                  >
                    <path d="M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z"></path>
                  </svg>
                </motion.div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>,
        modalRoot
      )
    : null;
}
